import { utagLinkGeneric } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

function initShowMoreBreadcrumbItems () {

	const showMoreBreadcrumbBtns = document.querySelectorAll('.breadcrumbNav__showMore');

	showMoreBreadcrumbBtns.forEach((showMoreBtn) => {

		const container = showMoreBtn.closest('.breadcrumbNav');
		if (container) {

			const showMoreIcon = showMoreBtn.querySelector('.breadcrumbNav__showMoreIcon');
			const showMoreText = showMoreBtn.querySelector('.breadcrumbNav__showMoreText');
			const allBreadcrumbItems = container.querySelectorAll('.breadcrumbNav__listItem');
			const hiddenBreadcrumbItems = container.querySelectorAll('.breadcrumbNav__listItem.hidden');
			const updateShowMoreText = (el:Element, text:string) => {

				if (el) {

					// eslint-disable-next-line no-param-reassign
					el.textContent = text;

				}

			};
			const toggleShowMoreBtn = (currentShowMoreText:string) => {

				const SHOW_MORE = 'Show More';
				const SHOW_LESS = 'Show Less';
				const SHOW_MORE_ICON = '+';
				const SHOW_LESS_ICON = '-';

				if (currentShowMoreText === SHOW_MORE) {

					updateShowMoreText(showMoreIcon, SHOW_LESS_ICON);
					updateShowMoreText(showMoreText, SHOW_LESS);

				} else {

					updateShowMoreText(showMoreIcon, SHOW_MORE_ICON);
					updateShowMoreText(showMoreText, SHOW_MORE);

				}

			};

			showMoreBtn.addEventListener('click', () => {

				const visibleBreadcrumbItems = [ ...allBreadcrumbItems ].filter((n) => !n.classList.contains('hidden'));
				const visibleBreadcrumbItemCount = visibleBreadcrumbItems.length.toString();
				const currentShowMoreText = showMoreText.textContent;

				hiddenBreadcrumbItems.forEach((bc) => bc.classList.toggle('hidden'));
				toggleShowMoreBtn(currentShowMoreText);

				utagLinkGeneric({
					eventCategory: 'Breadcrumb',
					eventAction: currentShowMoreText.replace(' ', '-'),
					eventLabel: visibleBreadcrumbItemCount
				});

				setGenericEvent({
					event_name: 'breadcrumb_click',
					breadcrumb_info: visibleBreadcrumbItemCount
				});

			});

		}

	});

}

export default initShowMoreBreadcrumbItems;
